import { menuItems, showRequestErrors } from '@softline/application';
import { ApiResourceLocation, ResourceService, SOFTLINE_SERVICE_HTTP, Store } from '@softline/core';
import { computed, inject, Inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MessageBarStore, modalFn, SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { ChangeBaustelleDialog } from '../dialogs/change-baustelle/change-baustelle.dialog';
import { GesamtabfrageListAddOn } from '@softapps/wws/gesamtabfrage/api';

@Injectable()
export class ChangeBaustelleAddOn extends GesamtabfrageListAddOn {

  private modal = modalFn();
  private store = inject(Store);

  constructor(@Inject(SOFTLINE_SERVICE_HTTP) private http: ResourceService<ApiResourceLocation>) {
    super();
    menuItems(() => {
      const hostParams = this.hostParams();
      if(!hostParams || hostParams.belegart()?.id !== 'Rechnungsprüfung')
        return [];
      return [{
        type: 'execute',
        name: '#GESAMTABFRAGE.ADD_ONS.CHANGE_BAUSTELLE.TITLE',
        title: '#GESAMTABFRAGE.ADD_ONS.CHANGE_BAUSTELLE.TITLE',
        icon: 'fa-regular fa-pen',
        outlet: 'action',
        canExecute: computed(() => {
          const selected = hostParams.selected();
          return selected.length === 1
            && selected[0].belegart.id === 'Rechnungspruefung'
            && !selected[0].fibudatum
        }),
        execute: async () => {
          const allSelected = hostParams.selected();
          if (allSelected.length !== 1)
            return;
          const selected = allSelected[0] as any;
          if (selected.belegart.id !== 'Rechnungspruefung')
            return;
          const result = await this.modal({
            component: ChangeBaustelleDialog,
            dismiss: true,
            data: { lieferadresse: selected.lieferadresse },
          })
          if(result === 'DISMISSED')
            return;

          try {
            const httpResult = await lastValueFrom(this.http.patch({
              path: "/abau/v1/gesamtabfrage/{{idbelegart}}/entities/{{idbeleg}}",
              pathParams: {
                idbelegart: selected.belegart.id,
                idbeleg: selected.id
              }
            }, {lieferadresse: {id: result.id}})) as any;
            //TODO: this.store.commit(SOFTLINE_FEATURE_GESAMTABFRAGE_BELEG, BelegStore.mutations.update, { ...selected, lieferadresse: httpResult.lieferadresse });
            await this.store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.success, 'Die Änderung wurde übernommen')
          }
          catch (e) {
            showRequestErrors(this.store, e);
          }
        }
      }]
    })
  }
}
